import type {AccessTokenService} from '@/domain/interfaces/AccessTokenService';

export class LogoutUseCase {
  constructor(private readonly repository: AccessTokenService) {}
  execute = () => {
    this.repository.remove();
  };
}
